import React, {useState} from "react";
import {FaEdit, FaTrash} from "react-icons/fa";

const AnsprechpartnerForm = ({register, errors, touchedFields, setValue, getValues, watch}) => {
    const [formVisible, setFormVisible] = useState(false);
    const entries = watch("ansprechpartnerListe") || [];
    const formData = watch("ansprechpartner") || {};
    const isFormValid = formData?.vorname && formData?.nachname && formData?.position && formData?.email;
    const [editIndex, setEditIndex] = useState(null);

    const handleAdd = () => {
        const data = getValues("ansprechpartner");

        if (
            isFormValid &&
            (data?.vorname && data?.nachname && data?.position && (data?.entscheider === "0" || data?.entscheider === "1"))
        ) {
            let updated;
            if (editIndex !== null) {
                updated = [...entries];
                updated[editIndex] = data;
            } else {
                updated = [...entries, data];
            }

            setValue("ansprechpartnerListe", updated);
            setValue("ansprechpartner", {
                anrede: "Frau",
                titel: "",
                vorname: "",
                nachname: "",
                position: "",
                email: "",
                durchwahl: "",
                mobil: "",
                privat: "",
                entscheider: "0",
            });
            setFormVisible(false);
            setEditIndex(null);
        }
    };

    const handleDelete = (indexToDelete) => {
        const updated = entries.filter((_, idx) => idx !== indexToDelete);
        setValue("ansprechpartnerListe", updated);
    };

    return (<div className="space-y-6">
        {/* Subtitle */}
        <h3 className="text-lg font-semibold text-grey text-left">Ansprechpartner</h3>
        <small className={`text-left block`} style={{marginTop: '0rem'}}>Geben Sie hier den oder die Ansprechpartner nacheinander ein.<br />
            Ist ein Ansprechpartner auch der "Entscheider" (=Vertragsunterzeichner), dann muss dieser auch als solcher gekennzeichnet sein.</small>

        {/* List of added Ansprechpartner */}
        {entries.length > 0 && (<div className="py-2 text-left bg-silver px-2">
            <h4 className="mb-2 font-semibold text-grey">Hinzugefügte Ansprechpartner:</h4>
            {entries.map((p, idx) => (
                <div key={idx} className="text-grey flex items-center mb-1 text-lg">
                    <button
                        type="button"
                        onClick={() => {
                            setValue("ansprechpartner", p);
                            setFormVisible(true);
                            setEditIndex(idx);
                        }}
                        className="text-blue-500 mr-2"
                        title="Bearbeiten"
                    >
                        <FaEdit />
                    </button>
                    <button
                        type="button"
                        onClick={() => handleDelete(idx)}
                        className="text-red-500 mr-2"
                        title="Löschen"
                    >
                        <FaTrash />
                    </button>
                    <span>{p.anrede} {p.titel} {p.vorname} {p.nachname} ({p.position})</span>
                </div>
            ))}
        </div>)}

        {/* Show "Add Ansprechpartner" button only when form is hidden */}
        {!formVisible && (<div className={`text-left`}>
            <button
                type="button"
                onClick={() => setFormVisible(true)}
                className="px-2 py-1 bg-lightBlue text-white rounded hover:bg-blue-600"
            >
                {entries.length === 0 ? 'Ansprechpartner hinzufügen' : 'Weiteren Ansprechpartner hinzufügen'}
            </button>
        </div>)}

        {/* Form + Radio */}
        {formVisible && (<>
            {/* Role toggle */}
            <div className="mb-4">
                <label className="text-sm font-medium text-grey text-left block">
                    Rolle *
                </label>
                <div className="flex items-center space-x-4 mt-2 text-sm ">
                    <label className="flex items-center space-x-2">
                        <input
                            type="radio"
                            value="0"
                            {...register("ansprechpartner.entscheider", { required: true })}
                            checked={formData?.entscheider === "0"}
                        />
                        <span>Ansprechpartner</span>
                    </label>
                    <label className="flex items-center space-x-2">
                        <input
                            type="radio"
                            value="1"
                            {...register("ansprechpartner.entscheider", { required: true })}
                            checked={formData?.entscheider === "1"}
                        />
                        <span>Entscheider</span>
                    </label>
                </div>
                {errors?.ansprechpartner?.entscheider && (
                    <p className="text-red-600 text-sm mt-1">Rolle ist erforderlich</p>
                )}
            </div>

            {/* Ansprechpartner Form */}
            <div className="grid 2xl:grid-cols-14 lg:grid-cols-10 md:grid-cols-2 gap-3 mt-8">
                <section className="flex flex-col text-left text-grey text-sm lg:col-span-2">
                    <label>Funktion *</label>
                    <select
                        className="p-3 bg-transparent border border-whiteDark rounded-lg"
                        {...register("ansprechpartner.position", { required: true })}
                        style={{ border: errors?.ansprechpartner?.position && "1px solid red" }}
                    >
                        <option value="">Bitte auswählen...</option>
                        <option value="Angestellter/in">Angestellter/in</option>
                        <option value="Aufsichtsrat">Aufsichtsrat</option>
                        <option value="Geschäftsführer/in">Geschäftsführer/in</option>
                        <option value="Gesellschafter/in">Gesellschafter/in</option>
                        <option value="Inhaber/in">Inhaber/in</option>
                        <option value="Kaufm. Leiter/in">Kaufm. Leiter/in</option>
                        <option value="Personalleiter/in">Personalleiter/in</option>
                        <option value="Prokurist/in">Prokurist/in</option>
                        <option value="Vorstand">Vorstand</option>
                        <option value="sonst (siehe Bemerkung)">sonst (siehe Bemerkung)</option>
                    </select>
                    {errors?.ansprechpartner?.position && touchedFields && (
                        <p className="text-red-600 text-sm mt-1">Funktion Feld ist erforderlich</p>
                    )}
                </section>


                <section className="flex flex-col 2xl:ml-4 2xl:mr-4 text-left text-grey text-sm">
                    <label>Anrede *</label>
                    <select
                        className="p-3 bg-transparent 2xl:-mr-6 border border-whiteDark rounded-lg"
                        {...register("ansprechpartner.anrede", {required: true})}
                        style={{border: errors?.ansprechpartner?.anrede && "1px solid red"}}
                    >
                        <option defaultValue value="Frau">Frau</option>
                        <option value="Herr">Herr</option>
                    </select>
                    {errors?.ansprechpartner?.anrede && touchedFields && (<p>Anrede Feld ist erforderlich</p>)}
                </section>

                <section
                    className="flex flex-col text-left 2xl:ml-6 2xl:-mr-6 text-grey text-sm 2xl:col-span-1 lg:col-span-2">
                    <label>Titel</label>
                    <input
                        placeholder="Titel..."
                        {...register("ansprechpartner.titel")}
                        style={{border: errors?.ansprechpartner?.titel && "1px solid red"}}
                    />
                </section>

                <section className="flex flex-col 2xl:ml-6 2xl:-mr-6 text-left text-grey text-sm">
                    <label>Vorname *</label>
                    <input
                        placeholder="Vorname..."
                        {...register("ansprechpartner.vorname", {required: true})}
                        style={{border: errors?.ansprechpartner?.vorname && "1px solid red"}}
                    />
                    {errors?.ansprechpartner?.vorname && touchedFields && (<p>Vorname Feld ist erforderlich</p>)}
                </section>

                <section className="flex flex-col 2xl:ml-6 2xl:-mr-6 text-left text-grey text-sm">
                    <label>Nachname *</label>
                    <input
                        placeholder="Nachname..."
                        {...register("ansprechpartner.nachname", {required: true})}
                        style={{border: errors?.ansprechpartner?.nachname && "1px solid red"}}
                    />
                    {errors?.ansprechpartner?.nachname && touchedFields && (<p>Nachname Feld ist erforderlich</p>)}
                </section>

                {/* Email (required) */}
                <section className="flex flex-col 2xl:ml-6 2xl:-mr-6 text-left text-grey text-sm lg:col-span-3">
                    <label>E-Mail *</label>
                    <input
                        placeholder="E-Mail"
                        {...register("ansprechpartner.email", {
                            required: "E-Mail Feld ist erforderlich", pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Bitte geben Sie eine gültige E-Mail ein"
                            }
                        })}
                        type="email"
                        style={{border: errors?.ansprechpartner?.email && "1px solid red"}}
                    />
                    {errors?.ansprechpartner?.email && touchedFields && (<p>{errors.ansprechpartner.email.message}</p>)}
                </section>

                <section className="flex flex-col 2xl:-mr-6 text-left text-grey text-sm lg:col-span-2">
                    <label>Durchwahl</label>
                    <input
                        placeholder="Durchwahl..."
                        {...register("ansprechpartner.durchwahl")}
                        style={{border: errors?.ansprechpartner?.durchwahl && "1px solid red"}}
                    />
                </section>

                <section className="flex flex-col 2xl:ml-6 2xl:-mr-6 text-left text-grey text-sm lg:col-span-2">
                    <label>Mobil</label>
                    <input
                        placeholder="Mobil..."
                        {...register("ansprechpartner.mobil")}
                        style={{border: errors?.ansprechpartner?.mobil && "1px solid red"}}
                    />
                </section>

                <section
                    className="flex flex-col 2xl:ml-6 2xl:-mr-6 text-left text-grey text-sm lg:col-span-4 2xl:col-span-3">
                    <label>Privat</label>
                    <input
                        placeholder="Privat..."
                        {...register("ansprechpartner.privat")}
                        style={{border: errors?.ansprechpartner?.privat && "1px solid red"}}
                    />
                </section>

                {/* Submit Button */}
                <div className="col-span-full mt-4 text-left">
                    <button
                        type="button"
                        onClick={handleAdd}
                        disabled={!isFormValid}
                        className={`px-2 py-1 rounded text-white ${isFormValid ? "bg-lightBlue hover:bg-blue-600" : "bg-whiteDark cursor-not-allowed"}`}
                    >
                        {editIndex !== null ? "Ansprechpartner aktualisieren" : "Ansprechpartner hinzufügen"}
                    </button>
                    {editIndex !== null && (
                        <button
                            type="button"
                            onClick={() => {
                                setEditIndex(null);
                                setFormVisible(false);
                                setValue("ansprechpartner", {
                                    anrede: "Frau",
                                    titel: "",
                                    vorname: "",
                                    nachname: "",
                                    position: "",
                                    email: "",
                                    durchwahl: "",
                                    mobil: "",
                                    privat: "",
                                    entscheider: "0",
                                });
                            }}
                            className="ml-2 px-2 py-1 rounded text-white bg-cancel hover:bg-gray-700"
                        >
                            Abbrechen
                        </button>
                    )}
                </div>
            </div>
        </>)}
    </div>);
};

export default AnsprechpartnerForm;
